export default __webpack_public_path__ + "static/media/home-main.b9847e1f.png";